import { createSvgIcon } from '@mui/material';

const TotalPhysical = createSvgIcon(
  <svg width="28" height="27" viewBox="0 0 28 27" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20.5 7.875L12.5 3.375L4.5 7.875M20.5 7.875V16.875L12.5 21.375M20.5 7.875L12.5 12.375M12.5 21.375L4.5 16.875V7.875M12.5 21.375V12.375M4.5 7.875L12.5 12.375M16.5 5.625L12.5 7.875L8.5 10.125"
      stroke="black"
      strokeWidth="0.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M27.5 12.9688L24 11L20.5 12.9688M27.5 12.9688V16.9062L24 18.875M27.5 12.9688L24 14.9375M24 18.875L20.5 16.9062V12.9688M24 18.875V14.9375M20.5 12.9688L24 14.9375M25.75 11.9844L24 12.9688L22.25 13.9531"
      stroke="black"
      strokeWidth="0.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
  'TotalPhysical',
);

export default TotalPhysical;
